import './PageSpinner.scss';

import Spinner from '../Spinner';

const PageSpinner = () => (
  <div className="c-PageSpinner">
    <Spinner />
  </div>
);

export default PageSpinner;
